import { render, staticRenderFns } from "./MaterialBuilder.vue?vue&type=template&id=8bf79596&"
import script from "./MaterialBuilder.vue?vue&type=script&lang=js&"
export * from "./MaterialBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports